<template>
  <div v-if="selectedChannels.includes('workflow') && multiVariant">
    <el-menu :default-active="defaultActive">
      <el-menu-item
        class="multi-variant-language"
        :index="`workflow-${variant.key}`"
        v-for="variant in variants"
        :key="variant.key"
        @click="createRoute('workflow', variant.key, 'default')"
      >
        <el-tooltip
          :disabled="variant.title.length <= 37"
          placement="bottom"
          effect="light"
        >
          <div class="tooltip-content" slot="content">
            <i class="winner el-icon-trophy" v-if="variant.key === 'W'" />
            <span v-else>{{ variant.key }}</span> - {{ variant.title }}
          </div>
          <span class="text-overflow">
            <i class="winner el-icon-trophy" v-if="variant.key === 'W'" />
            <span v-else>{{ variant.key }}</span> - {{ variant.title }}
          </span>
        </el-tooltip>
      </el-menu-item>
    </el-menu>
  </div>
  <div
    class="channel-container"
    v-else-if="!selectedChannels.find(channel => channel === 'workflow')"
  >
    <el-menu :default-active="defaultActive" v-if="!multiVariant && !multiLang">
      <el-menu-item
        v-for="channel in selectedChannels"
        :key="channel"
        @click="createRoute(channel, 'default', 'default')"
        :index="channel"
      >
        <div style="display: flex">
          <div class="icon-ct">
            <icon class="icon" :glyph="channelIcons[channel]" />
          </div>
          <span class="title">
            {{ $t(channels[channel]) }}
            <span class="changed-dot" v-if="isChanged(channel)"></span>
          </span>
        </div>
      </el-menu-item>
    </el-menu>
    <el-menu
      v-else-if="!multiVariant && multiLang"
      :default-active="defaultActive"
    >
      <el-submenu
        :index="channel"
        v-for="(channel, ci) in selectedChannels"
        :key="ci"
      >
        <template slot="title">
          <div style="display: flex">
            <div class="icon-ct">
              <icon class="icon" :glyph="channelIcons[channel]" />
            </div>
            <span slot="title" class="title">
              {{ $t(channels[channel]) }}
              <span class="changed-dot" v-if="isChanged(channel)"></span>
            </span>
          </div>
        </template>
        <el-menu-item-group>
          <el-menu-item
            class="multi-variant-language"
            v-for="lang in languages.filter(l => l !== '')"
            :key="lang"
            :index="`${channel}-${lang}`"
            @click="createRoute(channel, 'default', lang)"
          >
            <span slot="title"
              >{{ languagesList[lang] }}
              {{
                lang === languagesDefault
                  ? `(${$t('Campaign_MultiLanguage_Default').toLowerCase()})`
                  : null
              }}
            </span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <el-menu
      v-else-if="multiVariant && !multiLang"
      :default-active="defaultActive"
    >
      <el-submenu
        :index="channel"
        v-for="(channel, ci) in selectedChannels"
        :key="ci"
      >
        <template slot="title">
          <div style="display: flex">
            <div class="icon-ct">
              <icon class="icon" :glyph="channelIcons[channel]" />
            </div>
            <span slot="title" class="title">
              {{ $t(channels[channel]) }}
              <span class="changed-dot" v-if="isChanged(channel)"></span>
            </span>
          </div>
        </template>
        <el-menu-item-group>
          <el-menu-item
            class="multi-variant-language"
            :index="`${channel}-${variant.key}`"
            v-for="variant in variants"
            :key="variant.key"
            @click="createRoute(channel, variant.key, 'default')"
          >
            <el-tooltip
              :disabled="variant.title.length <= 37"
              placement="bottom"
              effect="light"
            >
              <div class="tooltip-content" slot="content">
                <i class="winner el-icon-trophy" v-if="variant.key === 'W'" />
                <span v-else>{{ variant.key }}</span> - {{ variant.title }}
              </div>
              <span class="text-overflow">
                <i class="winner el-icon-trophy" v-if="variant.key === 'W'" />
                <span v-else>{{ variant.key }}</span> - {{ variant.title }}
              </span>
            </el-tooltip>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <el-menu v-else :default-active="defaultActive">
      <el-submenu
        :index="channel"
        v-for="(channel, ci) in selectedChannels"
        :key="ci"
      >
        <template slot="title">
          <div style="display: flex">
            <div class="icon-ct">
              <icon class="icon" :glyph="channelIcons[channel]" />
            </div>
            <span slot="title" class="title">
              {{ $t(channels[channel]) }}
              <span class="changed-dot" v-if="isChanged(channel)"></span>
            </span>
          </div>
        </template>
        <el-menu-item-group v-for="variant in variants" :key="variant.key">
          <template slot="title">
            <div class="item-group-title">
              <el-tooltip
                :disabled="variant.title.length <= 37"
                placement="bottom"
                effect="light"
              >
                <div class="tooltip-content" slot="content">
                  <i class="winner el-icon-trophy" v-if="variant.key === 'W'" />
                  <span v-else>{{ variant.key }}</span> - {{ variant.title }}
                </div>
                <span class="text-overflow">
                  <i class="winner el-icon-trophy" v-if="variant.key === 'W'" />
                  <span v-else>{{ variant.key }}</span> - {{ variant.title }}
                </span>
              </el-tooltip>
            </div>
          </template>
          <el-menu-item
            class="multi-variant-language"
            v-for="lang in languages.filter(l => l !== '')"
            :index="`${channel}-${variant.key}-${lang}`"
            :key="lang"
            @click="createRoute(channel, variant.key, lang)"
          >
            <span>
              {{ languagesList[lang] }}
              {{
                lang === languagesDefault
                  ? `(${$t('Campaign_MultiLanguage_Default').toLowerCase()})`
                  : null
              }}
            </span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { projectRoute } from '@/core/helpers'
import {
  channelIcons,
  channelTypes
} from '@/modules/campaign-manage/enum/Labels'
import { languages as languagesList } from '@/modules/campaign-manage/enum/LanguagesEnum'
import _ from 'lodash'

export default {
  name: 'CampaignContentNav',

  props: {
    channels: {
      type: Object,
      required: true
    },
    selectedChannels: {
      type: Array,
      required: true
    },
    multiVariant: {
      type: [Boolean, Number],
      required: true,
      default: false
    },
    variants: {
      type: Array,
      required: true
    },
    multiLang: {
      type: [Boolean, Number],
      required: true,
      default: false
    },
    languages: {
      type: Array,
      required: true
    },
    languagesDefault: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      defaultActive: null,
      languagesList,
      channelIcons
    }
  },
  mounted() {
    const channel = this.$route.query.channel
      ? this.selectedChannels.includes(this.$route.query.channel)
        ? this.$route.query.channel
        : this.selectedChannels[0]
      : this.selectedChannels[0]

    const variant =
      this.$route.query.variant &&
      this.selectedChannels.includes(this.$route.query.channel)
        ? this.variants
            .map(item => item.key)
            .includes(this.$route.query.variant)
          ? this.$route.query.variant
          : this.variants[0].key
        : this.variants[0].key

    const lang =
      this.$route.query.lang &&
      this.selectedChannels.includes(this.$route.query.channel)
        ? this.languages.includes(this.$route.query.lang)
          ? this.$route.query.lang
          : this.languages[0]
        : this.languages[0]

    this.createRoute(
      channel,
      this.multiVariant ? variant : 'default',
      this.multiLang ? lang : 'default'
    )
    this.defaultActive =
      channel +
      (this.multiVariant ? `-${variant}` : '') +
      (this.multiLang ? `-${lang}` : '')
  },
  methods: {
    isChanged(ch) {
      if (
        this.$route.name !== 'ViewCampaignSnapshot' ||
        !this.model.snapshotPrevious ||
        !this.model.snapshotPrevious.value
      ) {
        return false
      }
      let channelKey = channelTypes[ch]
      return !_.isEqual(
        this.model.messages[channelKey] || null,
        this.model.snapshotPrevious.value.messages[channelKey] || null
      )
    },
    createRoute(channel, variant, lang) {
      let route = {
        name: this.$route.name,
        query: { ...this.$route.query },
        hash: this.$route.hash
      }
      route.query.channel = channel
      route.query.lang = lang
      route.query.variant = variant
      this.$router
        .push(projectRoute(route, this.$route.query.project_id))
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.el-menu {
  border-right: 0;
  padding: 8px 8px 8px 8px;
  background: #f8fafc;
  border-radius: 4px;
}

.winner {
  margin: 0;
}

.el-menu-item {
  font-weight: 600;
  font-size: 12px;
  color: #4b515f;
  min-width: inherit;
}

>>> .el-menu--inline {
  background: #f8fafc;
  border-radius: 4px;
}

span.title {
  font-weight: 600;
  font-size: 14px;
  color: #1d87c8;
}

>>> .el-submenu.is-active {
  color: #0087ce;
}

>>> .el-menu-item-group__title {
  font-weight: normal;
  font-size: 14px;
  color: #7e8596;
}

.item-group-title {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item-group-title span {
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.cog {
  margin-right: 20px;
}

.item-group-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

>>> .el-submenu__title {
  padding-left: 20px;
  display: flex;
  align-items: baseline;
  flex-direction: row-reverse;
  justify-content: flex-end;
}

>>> .el-menu-item-group__title {
  padding: 0;
}

>>> .el-menu-item-group {
  padding: 0 0 10px 0;
}

>>> .el-submenu__icon-arrow {
  color: #0087ce;
  font-weight: 800;
  position: unset;
  top: 0;
  right: 0;
  margin-right: 17px;
}
>>> .el-menu-item.is-active {
  background: #fff;
}
>>> .el-menu-item.is-active.multi-variant-language {
  color: #32404d;
  background: #fff;
}

>>> .el-menu-item.is-active.multi-variant-language > span {
  color: #1d87c8;
}

.tooltip-content {
  width: 300px;
}

.text-overflow {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.icon-ct {
  padding-right: 15px;
  font-size: 20px;
  color: #5c6374;
}

.icon-ct .icon {
  margin-bottom: 3px;
}
.changed-dot {
  height: 5px;
  width: 5px;
  background-color: #c81d87;
  border-radius: 50%;
  display: inline-block;
  vertical-align: text-top;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/CampaignContentNav.vue